module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d7cb3ae0db990e0bab94ac154ecedcd1.gif";